"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const isBlank_1 = __importDefault(require("./isBlank"));
const validationError_1 = __importDefault(require("./validationError"));
/**
 * Takes a password and throws an error if it's invalid. Returns the passord as-is if it passes validation.
 */
function validatePassword(password) {
    if (password.length < 6) {
        throw validationError_1.default("Password must be at least 6 characters and cannot be blank.");
    }
    if (isBlank_1.default(password)) {
        throw validationError_1.default("Password cannot be blank.");
    }
    return password;
}
exports.default = validatePassword;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidmFsaWRhdGVQYXNzd29yZC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy92YWxpZGF0ZVBhc3N3b3JkLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O0FBQUEsd0RBQWdDO0FBQ2hDLHdFQUFnRDtBQUVoRDs7R0FFRztBQUNILFNBQXdCLGdCQUFnQixDQUFDLFFBQWdCO0lBQ3ZELElBQUksUUFBUSxDQUFDLE1BQU0sR0FBRyxDQUFDLEVBQUU7UUFDdkIsTUFBTSx5QkFBZSxDQUNuQiw2REFBNkQsQ0FDOUQsQ0FBQztLQUNIO0lBRUQsSUFBSSxpQkFBTyxDQUFDLFFBQVEsQ0FBQyxFQUFFO1FBQ3JCLE1BQU0seUJBQWUsQ0FBQywyQkFBMkIsQ0FBQyxDQUFDO0tBQ3BEO0lBRUQsT0FBTyxRQUFRLENBQUM7QUFDbEIsQ0FBQztBQVpELG1DQVlDIn0=